declare var Chart;
declare var jQuery;

namespace TotalPoll {

    export class QuestionChartCanvas {
        public $choices;
        public chart;
        public settings: any = {
            data: [],
            type: 'bar',
            options: {
                tooltips: {},
                legend: {
                    display: true,
                    position: "bottom",
                    align: "center",
                    labels: {
                        padding: 30,
                    },
                },
                animation: {
                    duration: '1000',
                    easing: 'easeOut'
                }
            }
        };

        constructor(public $canvas, public poll) {
            this.settings.data = JSON.parse(this.$canvas.attr('totalpoll-chart-data'));
            this.settings.type = this.$canvas.attr('totalpoll-chart-type');
            if (this.settings.type === 'bar') {
                this.settings.options.legend.display = false;
                this.settings.options.scales = {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            callback: function (value, index, values) {
                                return value + '%';
                            }
                        }
                    }]
                }
            }

            this.settings.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return "\t" + data.labels[tooltipItem.index] + ": " + data.datasets[0].text[tooltipItem.index];
                }
            };
            this.settings.options.animation.duration = this.$canvas.attr('totalpoll-chart-animation-duration');
            this.settings.options.animation.easing = this.$canvas.attr('totalpoll-chart-animation-easing');
            this.$choices = this.$canvas.next('.totalpoll-question-choices').find('.totalpoll-question-choices-item');

            setTimeout(
                () => {
                    this.setupChart();
                    this.setupChoicesTooltips();
                },
                poll.config['effects']['duration']
            );
        }

        setupChart() {
            this.chart = new Chart(this.$canvas.get(0), this.settings);
        }

        setupChoicesTooltips() {
            // Initialize tooltips for legend items
            this.$choices.each((index, el) => {
                var tooltipSettings = {
                    _chart: this.chart.chart,
                    _chartInstance: this.chart,
                    _data: this.chart.data,
                    _options: this.chart.options.tooltips,
                    _active: [this.chart.getDatasetMeta(0).data[index]]
                };
                var tooltip = new Chart.Tooltip(tooltipSettings, this.chart);
                jQuery(el).data('totalpoll-chart-choice-tooltip', tooltip);
                tooltip.initialize();
            });

            // Draw tooltips on legend mouseover
            this.$choices.mouseover(function () {
                var tooltip = jQuery(this).data('totalpoll-chart-choice-tooltip');
                tooltip.update();
                tooltip.pivot();
                tooltip.transition('swing').draw();
            });

            // Remove tooltip on legend mouseout
            this.$choices.mouseout(() => {
                this.chart.draw();
            });
        }
    }

    // Any further actions
    TotalPoll['Hooks'].addAction("totalpoll/init", function (poll) {
        poll.element.find('[totalpoll-chart]').each((index, canvas) => {
            new QuestionChartCanvas(jQuery(canvas), poll);
        });
    });
}
